import { render, staticRenderFns } from "./mobileCodeDc.vue?vue&type=template&id=155bb984"
import script from "./mobileCodeDc.vue?vue&type=script&lang=js"
export * from "./mobileCodeDc.vue?vue&type=script&lang=js"
import style0 from "./mobileCodeDc.vue?vue&type=style&index=0&id=155bb984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports